var _a, _b;
/* eslint-disable max-lines */
export var GmailAnalyticsEnum;
(function (GmailAnalyticsEnum) {
    GmailAnalyticsEnum["GMAIL_EMAIL_SENT"] = "GMAIL_EMAIL_SENT";
    GmailAnalyticsEnum["GMAIL_EMAIL_RECEIVED"] = "GMAIL_EMAIL_RECEIVED";
})(GmailAnalyticsEnum || (GmailAnalyticsEnum = {}));
// mail_event_type codes: https://support.google.com/a/answer/12384955
export var GmailMailEventTypeEnum;
(function (GmailMailEventTypeEnum) {
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["MESSAGE_SENT"] = 1] = "MESSAGE_SENT";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["MESSAGE_RECEIVED"] = 2] = "MESSAGE_RECEIVED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["SPAM_CLASSIFICATION_APPLIED"] = 3] = "SPAM_CLASSIFICATION_APPLIED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["MESSAGE_OPENED"] = 7] = "MESSAGE_OPENED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["MESSAGE_REPLIED"] = 9] = "MESSAGE_REPLIED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["MESSAGE_FORWARDED"] = 10] = "MESSAGE_FORWARDED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["LINK_CLICKED"] = 15] = "LINK_CLICKED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["ATTACHMENT_LINK_CLICKED"] = 16] = "ATTACHMENT_LINK_CLICKED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["ATTACHMENT_DOWNLOADED"] = 17] = "ATTACHMENT_DOWNLOADED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["ATTACHMENT_SAVED_TO_DRIVE"] = 18] = "ATTACHMENT_SAVED_TO_DRIVE";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["ATTACHMENT_PREVIEWED"] = 28] = "ATTACHMENT_PREVIEWED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["MESSAGE_VIEWED"] = 31] = "MESSAGE_VIEWED";
    GmailMailEventTypeEnum[GmailMailEventTypeEnum["MESSAGE_DOWNLOADED"] = 32] = "MESSAGE_DOWNLOADED";
})(GmailMailEventTypeEnum || (GmailMailEventTypeEnum = {}));
export var GmailEventActionEnum;
(function (GmailEventActionEnum) {
    GmailEventActionEnum["GMAIL_MESSAGE_SENT"] = "GMAIL_MESSAGE_SENT";
    GmailEventActionEnum["GMAIL_MESSAGE_RECEIVED"] = "GMAIL_MESSAGE_RECEIVED";
    GmailEventActionEnum["GMAIL_SPAM_CLASSIFICATION_APPLIED"] = "GMAIL_SPAM_CLASSIFICATION_APPLIED";
    GmailEventActionEnum["GMAIL_MESSAGE_OPENED"] = "GMAIL_MESSAGE_OPENED";
    GmailEventActionEnum["GMAIL_MESSAGE_REPLIED"] = "GMAIL_MESSAGE_REPLIED";
    GmailEventActionEnum["GMAIL_MESSAGE_FORWARDED"] = "GMAIL_MESSAGE_FORWARDED";
    GmailEventActionEnum["GMAIL_LINK_CLICKED"] = "GMAIL_LINK_CLICKED";
    GmailEventActionEnum["GMAIL_ATTACHMENT_LINK_CLICKED"] = "GMAIL_ATTACHMENT_LINK_CLICKED";
    GmailEventActionEnum["GMAIL_ATTACHMENT_DOWNLOADED"] = "GMAIL_ATTACHMENT_DOWNLOADED";
    GmailEventActionEnum["GMAIL_ATTACHMENT_SAVED_TO_DRIVE"] = "GMAIL_ATTACHMENT_SAVED_TO_DRIVE";
    GmailEventActionEnum["GMAIL_ATTACHMENT_PREVIEWED"] = "GMAIL_ATTACHMENT_PREVIEWED";
    GmailEventActionEnum["GMAIL_MESSAGE_VIEWED"] = "GMAIL_MESSAGE_VIEWED";
    GmailEventActionEnum["GMAIL_MESSAGE_DOWNLOADED"] = "GMAIL_MESSAGE_DOWNLOADED";
})(GmailEventActionEnum || (GmailEventActionEnum = {}));
export var MAIL_EVENT_TYPE_TO_GMAIL_ACTION = (_a = {},
    _a[GmailMailEventTypeEnum.MESSAGE_SENT] = GmailEventActionEnum.GMAIL_MESSAGE_SENT,
    _a[GmailMailEventTypeEnum.MESSAGE_RECEIVED] = GmailEventActionEnum.GMAIL_MESSAGE_RECEIVED,
    _a[GmailMailEventTypeEnum.SPAM_CLASSIFICATION_APPLIED] = GmailEventActionEnum.GMAIL_SPAM_CLASSIFICATION_APPLIED,
    _a[GmailMailEventTypeEnum.MESSAGE_OPENED] = GmailEventActionEnum.GMAIL_MESSAGE_OPENED,
    _a[GmailMailEventTypeEnum.MESSAGE_REPLIED] = GmailEventActionEnum.GMAIL_MESSAGE_REPLIED,
    _a[GmailMailEventTypeEnum.MESSAGE_FORWARDED] = GmailEventActionEnum.GMAIL_MESSAGE_FORWARDED,
    _a[GmailMailEventTypeEnum.LINK_CLICKED] = GmailEventActionEnum.GMAIL_LINK_CLICKED,
    _a[GmailMailEventTypeEnum.ATTACHMENT_LINK_CLICKED] = GmailEventActionEnum.GMAIL_ATTACHMENT_LINK_CLICKED,
    _a[GmailMailEventTypeEnum.ATTACHMENT_DOWNLOADED] = GmailEventActionEnum.GMAIL_ATTACHMENT_DOWNLOADED,
    _a[GmailMailEventTypeEnum.ATTACHMENT_SAVED_TO_DRIVE] = GmailEventActionEnum.GMAIL_ATTACHMENT_SAVED_TO_DRIVE,
    _a[GmailMailEventTypeEnum.ATTACHMENT_PREVIEWED] = GmailEventActionEnum.GMAIL_ATTACHMENT_PREVIEWED,
    _a[GmailMailEventTypeEnum.MESSAGE_VIEWED] = GmailEventActionEnum.GMAIL_MESSAGE_VIEWED,
    _a[GmailMailEventTypeEnum.MESSAGE_DOWNLOADED] = GmailEventActionEnum.GMAIL_MESSAGE_DOWNLOADED,
    _a);
export var DefaultResponseCodeEnum;
(function (DefaultResponseCodeEnum) {
    DefaultResponseCodeEnum["SUCCESS"] = "SUCCESS";
    DefaultResponseCodeEnum["ERROR"] = "ERROR";
})(DefaultResponseCodeEnum || (DefaultResponseCodeEnum = {}));
export var StatusProcessingEnum;
(function (StatusProcessingEnum) {
    StatusProcessingEnum["PENDING"] = "PENDING";
    StatusProcessingEnum["PROCESSING"] = "PROCESSING";
    StatusProcessingEnum["FINISHED"] = "FINISHED";
    StatusProcessingEnum["ERROR"] = "ERROR";
})(StatusProcessingEnum || (StatusProcessingEnum = {}));
export var IntegrationEnum;
(function (IntegrationEnum) {
    IntegrationEnum["GOOGLE"] = "GOOGLE";
})(IntegrationEnum || (IntegrationEnum = {}));
export var ApplicationEnum;
(function (ApplicationEnum) {
    ApplicationEnum["GMAIL"] = "GMAIL";
    ApplicationEnum["DRIVE"] = "DRIVE";
    ApplicationEnum["MEET"] = "MEET";
    ApplicationEnum["CALENDAR"] = "CALENDAR";
    ApplicationEnum["CHAT"] = "CHAT";
    ApplicationEnum["GEMINI"] = "GEMINI";
})(ApplicationEnum || (ApplicationEnum = {}));
export var ApplicationGoogleEnum;
(function (ApplicationGoogleEnum) {
    ApplicationGoogleEnum["gmail"] = "gmail";
    ApplicationGoogleEnum["drive"] = "drive";
    ApplicationGoogleEnum["meet"] = "meet";
    ApplicationGoogleEnum["calendar"] = "calendar";
    ApplicationGoogleEnum["chat"] = "chat";
    ApplicationGoogleEnum["gemini"] = "gemini_in_workspace_apps";
})(ApplicationGoogleEnum || (ApplicationGoogleEnum = {}));
export var AnalyticsEntityGroupByEnum;
(function (AnalyticsEntityGroupByEnum) {
    AnalyticsEntityGroupByEnum["orgUnit"] = "orgUnit";
    AnalyticsEntityGroupByEnum["user"] = "user";
})(AnalyticsEntityGroupByEnum || (AnalyticsEntityGroupByEnum = {}));
export var ApplicationProcessingArray = [
    ApplicationEnum.DRIVE,
    ApplicationEnum.MEET,
    ApplicationEnum.CALENDAR,
    ApplicationEnum.CHAT,
    ApplicationEnum.GEMINI,
    ApplicationEnum.GMAIL
];
export var ExternalGoogleDriveDocTypeEnum;
(function (ExternalGoogleDriveDocTypeEnum) {
    ExternalGoogleDriveDocTypeEnum["SPREADSHEET"] = "spreadsheet";
    ExternalGoogleDriveDocTypeEnum["DOCUMENT"] = "document";
    ExternalGoogleDriveDocTypeEnum["PRESENTATION"] = "presentation";
    ExternalGoogleDriveDocTypeEnum["DRAWING"] = "drawing";
    ExternalGoogleDriveDocTypeEnum["FOLDER"] = "folder";
    ExternalGoogleDriveDocTypeEnum["PDF"] = "pdf";
    ExternalGoogleDriveDocTypeEnum["FORM"] = "form";
    ExternalGoogleDriveDocTypeEnum["PHOTO"] = "photo";
    ExternalGoogleDriveDocTypeEnum["VIDEO"] = "video";
    ExternalGoogleDriveDocTypeEnum["AUDIO"] = "audio";
    ExternalGoogleDriveDocTypeEnum["UNKNOWN"] = "unknown";
    ExternalGoogleDriveDocTypeEnum["SHORTCUT"] = "shortcut";
    ExternalGoogleDriveDocTypeEnum["SCRIPT"] = "script";
    ExternalGoogleDriveDocTypeEnum["SITE"] = "site";
    ExternalGoogleDriveDocTypeEnum["MAP"] = "map";
    ExternalGoogleDriveDocTypeEnum["BINARY"] = "binary";
})(ExternalGoogleDriveDocTypeEnum || (ExternalGoogleDriveDocTypeEnum = {}));
export var ExternalGoogleDriveEventNameEnum;
(function (ExternalGoogleDriveEventNameEnum) {
    ExternalGoogleDriveEventNameEnum["VIEW"] = "view";
    ExternalGoogleDriveEventNameEnum["EDIT"] = "edit";
    ExternalGoogleDriveEventNameEnum["CREATE"] = "create";
    ExternalGoogleDriveEventNameEnum["DELETE"] = "delete";
    ExternalGoogleDriveEventNameEnum["CHANGE_ACL_EDITORS"] = "change_acl_editors";
    ExternalGoogleDriveEventNameEnum["CHANGE_ACL_VIEWERS"] = "change_acl_viewers";
    ExternalGoogleDriveEventNameEnum["DOWNLOAD"] = "download";
    ExternalGoogleDriveEventNameEnum["SHARE"] = "share";
    ExternalGoogleDriveEventNameEnum["UNSHARE"] = "unshare";
    ExternalGoogleDriveEventNameEnum["RENAME"] = "rename";
    ExternalGoogleDriveEventNameEnum["MOVE"] = "move";
    ExternalGoogleDriveEventNameEnum["PRINT"] = "print";
    ExternalGoogleDriveEventNameEnum["COPY"] = "source_copy";
    ExternalGoogleDriveEventNameEnum["ADD_TO_FOLDER"] = "add_to_folder";
    ExternalGoogleDriveEventNameEnum["REMOVE_FROM_FOLDER"] = "remove_from_folder";
    ExternalGoogleDriveEventNameEnum["TRASH"] = "trash";
    ExternalGoogleDriveEventNameEnum["RESTORE"] = "restore";
    ExternalGoogleDriveEventNameEnum["CREATE_COMMENT"] = "create_comment";
    ExternalGoogleDriveEventNameEnum["EDIT_COMMENT"] = "edit_comment";
    ExternalGoogleDriveEventNameEnum["DELETE_COMMENT"] = "delete_comment";
    ExternalGoogleDriveEventNameEnum["RESOLVE_COMMENT"] = "resolve_comment";
    ExternalGoogleDriveEventNameEnum["REOPEN_COMMENT"] = "reopen_comment";
    ExternalGoogleDriveEventNameEnum["CREATE_SUGGESTION"] = "create_suggestion";
    ExternalGoogleDriveEventNameEnum["REJECT_SUGGESTION"] = "reject_suggestion";
    ExternalGoogleDriveEventNameEnum["DELETE_SUGGESTION"] = "delete_suggestion";
    ExternalGoogleDriveEventNameEnum["ACCEPT_SUGGESTION"] = "accept_suggestion";
    ExternalGoogleDriveEventNameEnum["REQUEST_ACCESS"] = "request_access";
    ExternalGoogleDriveEventNameEnum["CHANGE_DOCUMENT_VISIBILITY"] = "change_document_visibility";
    ExternalGoogleDriveEventNameEnum["CHANGE_USER_ACCESS"] = "change_user_access";
    ExternalGoogleDriveEventNameEnum["UPLOAD"] = "upload";
    ExternalGoogleDriveEventNameEnum["SEND_TO_EMAIL"] = "email_as_attachment";
    ExternalGoogleDriveEventNameEnum["EMAIL_COLLABORATORS"] = "email_collaborators";
    ExternalGoogleDriveEventNameEnum["PUBLISH"] = "publish_change";
    ExternalGoogleDriveEventNameEnum["APPROVAL_REQUESTED"] = "approval_requested";
    ExternalGoogleDriveEventNameEnum["APPROVAL_REVIEWER_RESPONDED"] = "approval_reviewer_responded";
    ExternalGoogleDriveEventNameEnum["APPROVAL_COMPLETED"] = "approval_completed";
    ExternalGoogleDriveEventNameEnum["APPROVAL_CANCELED"] = "approval_canceled";
})(ExternalGoogleDriveEventNameEnum || (ExternalGoogleDriveEventNameEnum = {}));
export var ExternalGoogleDriveDocSharedEnum;
(function (ExternalGoogleDriveDocSharedEnum) {
    ExternalGoogleDriveDocSharedEnum["PEOPLE_WITHIN_DOMAIN_WITH_LINK"] = "people_within_domain_with_link";
    ExternalGoogleDriveDocSharedEnum["PUBLIC_IN_THE_DOMAIN"] = "public_in_the_domain";
    ExternalGoogleDriveDocSharedEnum["PRIVATE"] = "private";
    ExternalGoogleDriveDocSharedEnum["PEOPLE_WITH_LINK"] = "people_with_link";
    ExternalGoogleDriveDocSharedEnum["SHARED_EXTERNALLY"] = "shared_externally";
    ExternalGoogleDriveDocSharedEnum["SHARED_INTERNALLY"] = "shared_internally";
})(ExternalGoogleDriveDocSharedEnum || (ExternalGoogleDriveDocSharedEnum = {}));
export var DocumentSharingStatusEnum;
(function (DocumentSharingStatusEnum) {
    DocumentSharingStatusEnum["INTERNAL"] = "internal";
    DocumentSharingStatusEnum["EXTERNAL"] = "external";
    DocumentSharingStatusEnum["PUBLIC_LINK"] = "publicLink";
})(DocumentSharingStatusEnum || (DocumentSharingStatusEnum = {}));
export var DOCUMENT_SHARING_STATUS_ORDER = [
    DocumentSharingStatusEnum.INTERNAL,
    DocumentSharingStatusEnum.EXTERNAL,
    DocumentSharingStatusEnum.PUBLIC_LINK
];
export var DriveEventActionEnum;
(function (DriveEventActionEnum) {
    DriveEventActionEnum["DOCUMENT_VIEW"] = "DOCUMENT_VIEW";
    DriveEventActionEnum["DOCUMENT_EDIT"] = "DOCUMENT_EDIT";
    DriveEventActionEnum["DOCUMENT_CREATE"] = "DOCUMENT_CREATE";
    DriveEventActionEnum["DOCUMENT_DELETE"] = "DOCUMENT_DELETE";
    DriveEventActionEnum["DOCUMENT_CHANGE_ACL_EDITORS"] = "DOCUMENT_CHANGE_ACL_EDITORS";
    DriveEventActionEnum["DOCUMENT_CHANGE_ACL_VIEWERS"] = "DOCUMENT_CHANGE_ACL_VIEWERS";
    DriveEventActionEnum["DOCUMENT_DOWNLOAD"] = "DOCUMENT_DOWNLOAD";
    DriveEventActionEnum["DOCUMENT_SHARE"] = "DOCUMENT_SHARE";
    DriveEventActionEnum["DOCUMENT_UNSHARE"] = "DOCUMENT_UNSHARE";
    DriveEventActionEnum["DOCUMENT_RENAME"] = "DOCUMENT_RENAME";
    DriveEventActionEnum["DOCUMENT_MOVE"] = "DOCUMENT_MOVE";
    DriveEventActionEnum["DOCUMENT_PRINT"] = "DOCUMENT_PRINT";
    DriveEventActionEnum["DOCUMENT_COPY"] = "DOCUMENT_COPY";
    DriveEventActionEnum["DOCUMENT_ADD_TO_FOLDER"] = "DOCUMENT_ADD_TO_FOLDER";
    DriveEventActionEnum["DOCUMENT_REMOVE_FROM_FOLDER"] = "DOCUMENT_REMOVE_FROM_FOLDER";
    DriveEventActionEnum["DOCUMENT_TRASH"] = "DOCUMENT_TRASH";
    DriveEventActionEnum["DOCUMENT_RESTORE"] = "DOCUMENT_RESTORE";
    DriveEventActionEnum["DOCUMENT_CREATE_COMMENT"] = "DOCUMENT_CREATE_COMMENT";
    DriveEventActionEnum["DOCUMENT_EDIT_COMMENT"] = "DOCUMENT_EDIT_COMMENT";
    DriveEventActionEnum["DOCUMENT_DELETE_COMMENT"] = "DOCUMENT_DELETE_COMMENT";
    DriveEventActionEnum["DOCUMENT_RESOLVE_COMMENT"] = "DOCUMENT_RESOLVE_COMMENT";
    DriveEventActionEnum["DOCUMENT_REOPEN_COMMENT"] = "DOCUMENT_REOPEN_COMMENT";
    DriveEventActionEnum["DOCUMENT_CREATE_SUGGESTION"] = "DOCUMENT_CREATE_SUGGESTION";
    DriveEventActionEnum["DOCUMENT_REJECT_SUGGESTION"] = "DOCUMENT_REJECT_SUGGESTION";
    DriveEventActionEnum["DOCUMENT_DELETE_SUGGESTION"] = "DOCUMENT_DELETE_SUGGESTION";
    DriveEventActionEnum["DOCUMENT_ACCEPT_SUGGESTION"] = "DOCUMENT_ACCEPT_SUGGESTION";
    DriveEventActionEnum["DOCUMENT_REQUEST_ACCESS"] = "DOCUMENT_REQUEST_ACCESS";
    DriveEventActionEnum["DOCUMENT_CHANGE_ACCESS"] = "DOCUMENT_CHANGE_ACCESS";
    DriveEventActionEnum["DOCUMENT_UPLOAD"] = "DOCUMENT_UPLOAD";
    DriveEventActionEnum["DOCUMENT_SEND_TO_EMAIL"] = "DOCUMENT_SEND_TO_EMAIL";
    DriveEventActionEnum["DOCUMENT_PUBLISH"] = "DOCUMENT_PUBLISH";
    DriveEventActionEnum["DOCUMENT_APPROVAL_REQUESTED"] = "DOCUMENT_APPROVAL_REQUESTED";
    DriveEventActionEnum["DOCUMENT_APPROVAL_REVIEWER_RESPONDED"] = "DOCUMENT_APPROVAL_REVIEWER_RESPONDED";
    DriveEventActionEnum["DOCUMENT_APPROVAL_COMPLETED"] = "DOCUMENT_APPROVAL_COMPLETED";
    DriveEventActionEnum["DOCUMENT_APPROVAL_CANCELED"] = "DOCUMENT_APPROVAL_CANCELED";
})(DriveEventActionEnum || (DriveEventActionEnum = {}));
export var DriveEventSubActionEnum;
(function (DriveEventSubActionEnum) {
    DriveEventSubActionEnum["DOCUMENT_PEOPLE_WITHIN_DOMAIN_WITH_LINK"] = "DOCUMENT_PEOPLE_WITHIN_DOMAIN_WITH_LINK";
    DriveEventSubActionEnum["DOCUMENT_PUBLIC_IN_THE_DOMAIN"] = "DOCUMENT_PUBLIC_IN_THE_DOMAIN";
    DriveEventSubActionEnum["DOCUMENT_PRIVATE"] = "DOCUMENT_PRIVATE";
    DriveEventSubActionEnum["DOCUMENT_PEOPLE_WITH_LINK"] = "DOCUMENT_PEOPLE_WITH_LINK";
    DriveEventSubActionEnum["DOCUMENT_SHARED_EXTERNALLY"] = "DOCUMENT_SHARED_EXTERNALLY";
    DriveEventSubActionEnum["DOCUMENT_SHARED_INTERNALLY"] = "DOCUMENT_SHARED_INTERNALLY";
    DriveEventSubActionEnum["DOCUMENT_TRANSFER_OWNERSHIP"] = "DOCUMENT_TRANSFER_OWNERSHIP";
})(DriveEventSubActionEnum || (DriveEventSubActionEnum = {}));
export var DocumentTypeEnum;
(function (DocumentTypeEnum) {
    DocumentTypeEnum["SPREADSHEET"] = "SPREADSHEET";
    DocumentTypeEnum["DOCUMENT"] = "DOCUMENT";
    DocumentTypeEnum["PRESENTATION"] = "PRESENTATION";
    DocumentTypeEnum["DRAWING"] = "DRAWING";
    DocumentTypeEnum["FOLDER"] = "FOLDER";
    DocumentTypeEnum["PDF"] = "PDF";
    DocumentTypeEnum["FORM"] = "FORM";
    DocumentTypeEnum["PHOTO"] = "PHOTO";
    DocumentTypeEnum["VIDEO"] = "VIDEO";
    DocumentTypeEnum["AUDIO"] = "AUDIO";
    DocumentTypeEnum["UNKNOWN"] = "UNKNOWN";
    DocumentTypeEnum["SHORTCUT"] = "SHORTCUT";
    DocumentTypeEnum["SCRIPT"] = "SCRIPT";
    DocumentTypeEnum["SITE"] = "SITE";
    DocumentTypeEnum["MAP"] = "MAP";
    DocumentTypeEnum["BINARY"] = "BINARY";
    DocumentTypeEnum["OTHER"] = "OTHER";
})(DocumentTypeEnum || (DocumentTypeEnum = {}));
export var PrimaryDocumentTypes;
(function (PrimaryDocumentTypes) {
    PrimaryDocumentTypes["SPREADSHEET"] = "SPREADSHEET";
    PrimaryDocumentTypes["DOCUMENT"] = "DOCUMENT";
    PrimaryDocumentTypes["PRESENTATION"] = "PRESENTATION";
})(PrimaryDocumentTypes || (PrimaryDocumentTypes = {}));
export var DocumentInsightsEnum;
(function (DocumentInsightsEnum) {
    DocumentInsightsEnum["mostCommented"] = "mostCommented";
    DocumentInsightsEnum["mostChangesSuggested"] = "mostChangesSuggested";
    DocumentInsightsEnum["approvalRequested"] = "approvalRequested";
    DocumentInsightsEnum["topViewed"] = "topViewed";
    DocumentInsightsEnum["topCopied"] = "topCopied";
    DocumentInsightsEnum["unresolvedComments"] = "unresolvedComments";
    DocumentInsightsEnum["suggestionsPending"] = "suggestionsPending";
    DocumentInsightsEnum["approvalPending"] = "approvalPending";
    DocumentInsightsEnum["topEdited"] = "topEdited";
    DocumentInsightsEnum["topDownloaded"] = "topDownloaded";
})(DocumentInsightsEnum || (DocumentInsightsEnum = {}));
export var QueueSyncEnum;
(function (QueueSyncEnum) {
    QueueSyncEnum["USERS"] = "USERS";
    QueueSyncEnum["ORG_UNITS"] = "ORG_UNITS";
    QueueSyncEnum["MEMBERS_ORG_UNITS"] = "MEMBERS_ORG_UNITS";
    QueueSyncEnum["GROUPS"] = "GROUPS";
    QueueSyncEnum["MEMBERS_GROUPS"] = "MEMBERS_GROUPS";
    QueueSyncEnum["DOMAINS"] = "DOMAINS";
})(QueueSyncEnum || (QueueSyncEnum = {}));
export var SortOrderEnum;
(function (SortOrderEnum) {
    SortOrderEnum["ASC"] = "asc";
    SortOrderEnum["DESC"] = "desc";
})(SortOrderEnum || (SortOrderEnum = {}));
export var JobsEventEnum;
(function (JobsEventEnum) {
    JobsEventEnum["SYNC"] = "SYNC";
    JobsEventEnum["SUBSCRIBE_TO_WEBHOOK_EVENTS"] = "SUBSCRIBE_TO_WEBHOOK_EVENTS";
    JobsEventEnum["CHECK_ACTIVITY_ALERT"] = "CHECK_ACTIVITY_ALERT";
    JobsEventEnum["EXPIRY_DATE_PLANS"] = "EXPIRY_DATE_PLANS";
    JobsEventEnum["SUSPEND_SUBSCRIPTION"] = "SUSPEND_SUBSCRIPTION";
    JobsEventEnum["DELETE_WORKSPACE"] = "DELETE_WORKSPACE";
    JobsEventEnum["UPDATE_SUBSCRIPTION"] = "UPDATE_SUBSCRIPTION";
    JobsEventEnum["RECOMPUTE_USER_DAILY_METRICS"] = "RECOMPUTE_USER_DAILY_METRICS";
})(JobsEventEnum || (JobsEventEnum = {}));
export var ExternalGoogleCalendarEventNameEnum;
(function (ExternalGoogleCalendarEventNameEnum) {
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT"] = "change_event";
    ExternalGoogleCalendarEventNameEnum["CREATE_EVENT"] = "create_event";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_START_TIME"] = "change_event_start_time";
    ExternalGoogleCalendarEventNameEnum["ADD_EVENT_GUEST"] = "add_event_guest";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_GUEST_RESPONSE"] = "change_event_guest_response";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_TITLE"] = "change_event_title";
    ExternalGoogleCalendarEventNameEnum["DELETE_EVENT"] = "delete_event";
    ExternalGoogleCalendarEventNameEnum["ADD_EVENT"] = "add_event";
    ExternalGoogleCalendarEventNameEnum["UPDATE_EVENT_DESCRIPTION"] = "update_event_description";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_LOCATION"] = "change_event_location";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_END_TIME"] = "change_event_end_time";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_RECURRENCE"] = "change_event_recurrence";
    ExternalGoogleCalendarEventNameEnum["UPDATE_EVENT_ATTACHMENTS"] = "update_event_attachments";
    ExternalGoogleCalendarEventNameEnum["UPDATE_EVENT_REMINDERS"] = "update_event_reminders";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_STATUS"] = "change_event_status";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_ORGANIZER"] = "change_event_organizer";
    ExternalGoogleCalendarEventNameEnum["CHANGE_EVENT_COLOR"] = "change_event_color";
    ExternalGoogleCalendarEventNameEnum["UPDATE_EVENT_GUESTS"] = "update_event_guests";
    ExternalGoogleCalendarEventNameEnum["REMOVE_EVENT_GUEST"] = "remove_event_guest";
})(ExternalGoogleCalendarEventNameEnum || (ExternalGoogleCalendarEventNameEnum = {}));
export var CalendarEventActionEnum;
(function (CalendarEventActionEnum) {
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT"] = "CALENDAR_CHANGE_EVENT";
    CalendarEventActionEnum["CALENDAR_CREATE_EVENT"] = "CALENDAR_CREATE_EVENT";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_START_TIME"] = "CALENDAR_CHANGE_EVENT_START_TIME";
    CalendarEventActionEnum["CALENDAR_ADD_EVENT_GUEST"] = "CALENDAR_ADD_EVENT_GUEST";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_GUEST_RESPONSE"] = "CALENDAR_CHANGE_EVENT_GUEST_RESPONSE";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_TITLE"] = "CALENDAR_CHANGE_EVENT_TITLE";
    CalendarEventActionEnum["CALENDAR_DELETE_EVENT"] = "CALENDAR_DELETE_EVENT";
    CalendarEventActionEnum["CALENDAR_ADD_EVENT"] = "CALENDAR_ADD_EVENT";
    CalendarEventActionEnum["CALENDAR_UPDATE_EVENT_DESCRIPTION"] = "CALENDAR_UPDATE_EVENT_DESCRIPTION";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_LOCATION"] = "CALENDAR_CHANGE_EVENT_LOCATION";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_END_TIME"] = "CALENDAR_CHANGE_EVENT_END_TIME";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_RECURRENCE"] = "CALENDAR_CHANGE_EVENT_RECURRENCE";
    CalendarEventActionEnum["CALENDAR_UPDATE_EVENT_ATTACHMENTS"] = "CALENDAR_UPDATE_EVENT_ATTACHMENTS";
    CalendarEventActionEnum["CALENDAR_UPDATE_EVENT_REMINDERS"] = "CALENDAR_UPDATE_EVENT_REMINDERS";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_STATUS"] = "CALENDAR_CHANGE_EVENT_STATUS";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_ORGANIZER"] = "CALENDAR_CHANGE_EVENT_ORGANIZER";
    CalendarEventActionEnum["CALENDAR_CHANGE_EVENT_COLOR"] = "CALENDAR_CHANGE_EVENT_COLOR";
    CalendarEventActionEnum["CALENDAR_UPDATE_EVENT_GUESTS"] = "CALENDAR_UPDATE_EVENT_GUESTS";
    CalendarEventActionEnum["CALENDAR_REMOVE_EVENT_GUEST"] = "CALENDAR_REMOVE_EVENT_GUEST";
})(CalendarEventActionEnum || (CalendarEventActionEnum = {}));
export var ExternalGoogleMeetEventNameEnum;
(function (ExternalGoogleMeetEventNameEnum) {
    ExternalGoogleMeetEventNameEnum["CALL_ENDED"] = "call_ended";
    ExternalGoogleMeetEventNameEnum["PRESENTATION_STARTED"] = "presentation_started";
    ExternalGoogleMeetEventNameEnum["PRESENTATION_STOPPED"] = "presentation_stopped";
    ExternalGoogleMeetEventNameEnum["KNOCKING_ACCEPTED"] = "knocking_accepted";
    ExternalGoogleMeetEventNameEnum["TRANSCRIPTION_ACTIVITY"] = "transcription_activity";
    ExternalGoogleMeetEventNameEnum["KNOCKING_DENIED"] = "knocking_denied";
    ExternalGoogleMeetEventNameEnum["RECORDING_ACTIVITY"] = "recording_activity";
    ExternalGoogleMeetEventNameEnum["RING_SENT"] = "ring_sent";
    ExternalGoogleMeetEventNameEnum["RING_ANSWERED"] = "ring_answered";
    ExternalGoogleMeetEventNameEnum["RING_MISSED"] = "ring_missed";
})(ExternalGoogleMeetEventNameEnum || (ExternalGoogleMeetEventNameEnum = {}));
export var MeetEventActionEnum;
(function (MeetEventActionEnum) {
    MeetEventActionEnum["MEET_CALL_ENDED"] = "MEET_CALL_ENDED";
    MeetEventActionEnum["MEET_PRESENTATION_STARTED"] = "MEET_PRESENTATION_STARTED";
    MeetEventActionEnum["MEET_PRESENTATION_STOPPED"] = "MEET_PRESENTATION_STOPPED";
    MeetEventActionEnum["MEET_KNOCKING_ACCEPTED"] = "MEET_KNOCKING_ACCEPTED";
    MeetEventActionEnum["MEET_TRANSCRIPTION_ACTIVITY"] = "MEET_TRANSCRIPTION_ACTIVITY";
    MeetEventActionEnum["MEET_KNOCKING_DENIED"] = "MEET_KNOCKING_DENIED";
    MeetEventActionEnum["MEET_RECORDING_ACTIVITY"] = "MEET_RECORDING_ACTIVITY";
    MeetEventActionEnum["MEET_RING_SENT"] = "MEET_RING_SENT";
    MeetEventActionEnum["MEET_RING_ANSWERED"] = "MEET_RING_ANSWERED";
    MeetEventActionEnum["MEET_RING_MISSED"] = "MEET_RING_MISSED";
})(MeetEventActionEnum || (MeetEventActionEnum = {}));
export var AnalyticPeriodsEnum;
(function (AnalyticPeriodsEnum) {
    AnalyticPeriodsEnum["HOUR"] = "HOUR";
    AnalyticPeriodsEnum["DAY"] = "DAY";
    AnalyticPeriodsEnum["WEEK"] = "WEEK";
    AnalyticPeriodsEnum["MONTH"] = "MONTH";
})(AnalyticPeriodsEnum || (AnalyticPeriodsEnum = {}));
export var ReportTypes;
(function (ReportTypes) {
    ReportTypes["DAILY"] = "DAILY_REPORT";
    ReportTypes["WEEKLY"] = "WEEKLY_REPORT";
    ReportTypes["MONTHLY"] = "MONTHLY_REPORT";
})(ReportTypes || (ReportTypes = {}));
export var ActivityAlertTypeEnum;
(function (ActivityAlertTypeEnum) {
    ActivityAlertTypeEnum["USER_SENT_MORE_THAN_X_EMAILS_PER_DAY"] = "USER_SENT_MORE_THAN_X_EMAILS_PER_DAY";
    ActivityAlertTypeEnum["USER_SENT_LESS_THAN_X_EMAILS_PER_DAY"] = "USER_SENT_LESS_THAN_X_EMAILS_PER_DAY";
    ActivityAlertTypeEnum["USER_CREATED_OR_EDITED_LESS_THAN_X_PER_DAY"] = "USER_CREATED_OR_EDITED_LESS_THAN_X_PER_DAY";
    ActivityAlertTypeEnum["USER_SKIPPED_THE_RECURRING_MEETING"] = "USER_SKIPPED_THE_RECURRING_MEETING";
    ActivityAlertTypeEnum["USER_HOSTED_MEETING_X_MINS_THAN_SCHEDULED"] = "USER_HOSTED_MEETING_X_MINS_THAN_SCHEDULED";
})(ActivityAlertTypeEnum || (ActivityAlertTypeEnum = {}));
export var DocumentAlertActionEnum;
(function (DocumentAlertActionEnum) {
    DocumentAlertActionEnum["DOCUMENT_EDIT"] = "DOCUMENT_EDIT";
    DocumentAlertActionEnum["DOCUMENT_COPY"] = "DOCUMENT_COPY";
    DocumentAlertActionEnum["DOCUMENT_DOWNLOAD"] = "DOCUMENT_DOWNLOAD";
    DocumentAlertActionEnum["DOCUMENT_SHARE"] = "DOCUMENT_SHARE";
    DocumentAlertActionEnum["DOCUMENT_SHARED_EXTERNALLY"] = "DOCUMENT_SHARED_EXTERNALLY";
    DocumentAlertActionEnum["DOCUMENT_SHARE_VIA_LINK"] = "DOCUMENT_SHARE_VIA_LINK";
    DocumentAlertActionEnum["DOCUMENT_REQUEST_ACCESS"] = "DOCUMENT_REQUEST_ACCESS";
    DocumentAlertActionEnum["DOCUMENT_PRINT"] = "DOCUMENT_PRINT";
    DocumentAlertActionEnum["DOCUMENT_DELETE"] = "DOCUMENT_DELETE";
    DocumentAlertActionEnum["DOCUMENT_TRASH"] = "DOCUMENT_TRASH";
    DocumentAlertActionEnum["DOCUMENT_RENAME"] = "DOCUMENT_RENAME";
    DocumentAlertActionEnum["DOCUMENT_MOVE"] = "DOCUMENT_MOVE";
    DocumentAlertActionEnum["DOCUMENT_SEND_TO_EMAIL"] = "DOCUMENT_SEND_TO_EMAIL";
    DocumentAlertActionEnum["DOCUMENT_PUBLISH"] = "DOCUMENT_PUBLISH";
})(DocumentAlertActionEnum || (DocumentAlertActionEnum = {}));
export var ExternalGoogleChatRoomTypeEnum;
(function (ExternalGoogleChatRoomTypeEnum) {
    ExternalGoogleChatRoomTypeEnum["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    ExternalGoogleChatRoomTypeEnum["SPACE"] = "SPACE";
    ExternalGoogleChatRoomTypeEnum["USER_TO_USER_DIRECT_MESSAGE"] = "USER_TO_USER_DIRECT_MESSAGE";
    ExternalGoogleChatRoomTypeEnum["THREAD"] = "THREAD";
    ExternalGoogleChatRoomTypeEnum["ROOM"] = "ROOM";
    ExternalGoogleChatRoomTypeEnum["PRIVATE"] = "PRIVATE";
    ExternalGoogleChatRoomTypeEnum["USER_TO_APP_DIRECT_MESSAGE"] = "USER_TO_APP_DIRECT_MESSAGE";
})(ExternalGoogleChatRoomTypeEnum || (ExternalGoogleChatRoomTypeEnum = {}));
export var ExternalGoogleChatRoomAccessEnum;
(function (ExternalGoogleChatRoomAccessEnum) {
    ExternalGoogleChatRoomAccessEnum["ENABLED"] = "ENABLED";
    ExternalGoogleChatRoomAccessEnum["DISABLED"] = "DISABLED";
})(ExternalGoogleChatRoomAccessEnum || (ExternalGoogleChatRoomAccessEnum = {}));
export var ChatRoomTypeEnum;
(function (ChatRoomTypeEnum) {
    ChatRoomTypeEnum["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    ChatRoomTypeEnum["SPACE"] = "SPACE";
    ChatRoomTypeEnum["USER_TO_USER_DIRECT_MESSAGE"] = "USER_TO_USER_DIRECT_MESSAGE";
    ChatRoomTypeEnum["THREAD"] = "THREAD";
    ChatRoomTypeEnum["ROOM"] = "ROOM";
    ChatRoomTypeEnum["PRIVATE"] = "PRIVATE";
    ChatRoomTypeEnum["UNKNOWN"] = "UNKNOWN";
    ChatRoomTypeEnum["USER_TO_APP_DIRECT_MESSAGE"] = "USER_TO_APP_DIRECT_MESSAGE";
})(ChatRoomTypeEnum || (ChatRoomTypeEnum = {}));
export var CHAT_DEFAULT_TITLE = 'Default Chat';
export var ExternalGooglChatEventNameEnum;
(function (ExternalGooglChatEventNameEnum) {
    ExternalGooglChatEventNameEnum["ROOM_CREATED"] = "room_created";
    ExternalGooglChatEventNameEnum["ADD_ROOM_MEMBER"] = "add_room_member";
    ExternalGooglChatEventNameEnum["REMOVE_ROOM_MEMBER"] = "remove_room_member";
    ExternalGooglChatEventNameEnum["ATTACHMENT_DOWNLOAD"] = "attachment_download";
    ExternalGooglChatEventNameEnum["MESSAGE_POSTED"] = "message_posted";
    ExternalGooglChatEventNameEnum["CONVERSATION_READ"] = "conversation_read";
    ExternalGooglChatEventNameEnum["ROOM_LEFT"] = "room_left";
    ExternalGooglChatEventNameEnum["UNREAD_TIMESTAMP_UPDATED"] = "unread_timestamp_updated";
    ExternalGooglChatEventNameEnum["ROOM_DELETED"] = "room_deleted";
    ExternalGooglChatEventNameEnum["ATTACHMENT_UPLOAD"] = "attachment_upload";
    ExternalGooglChatEventNameEnum["REACTION_ADDED"] = "reaction_added";
    ExternalGooglChatEventNameEnum["HISTORY_TURNED_ON"] = "history_turned_on";
    ExternalGooglChatEventNameEnum["MESSAGE_DELETED"] = "message_deleted";
    ExternalGooglChatEventNameEnum["MESSAGE_EDITED"] = "message_edited";
    ExternalGooglChatEventNameEnum["DIRECT_MESSAGE_STARTED"] = "direct_message_started";
    ExternalGooglChatEventNameEnum["REACTION_REMOVED"] = "reaction_removed";
    ExternalGooglChatEventNameEnum["INVITE_ACCEPT"] = "invite_accept";
    ExternalGooglChatEventNameEnum["ROOM_DETAILS_UPDATED"] = "room_details_updated";
    ExternalGooglChatEventNameEnum["ROOM_NAME_UPDATED"] = "room_name_updated";
    ExternalGooglChatEventNameEnum["INVITE_SEND"] = "invite_send";
    ExternalGooglChatEventNameEnum["ROLE_UPDATED"] = "role_updated";
})(ExternalGooglChatEventNameEnum || (ExternalGooglChatEventNameEnum = {}));
export var ChatEventActionEnum;
(function (ChatEventActionEnum) {
    ChatEventActionEnum["CHAT_ROOM_CREATED"] = "CHAT_ROOM_CREATED";
    ChatEventActionEnum["CHAT_ADD_ROOM_MEMBER"] = "CHAT_ADD_ROOM_MEMBER";
    ChatEventActionEnum["CHAT_REMOVE_ROOM_MEMBER"] = "REMOVE_ROOM_MEMBER";
    ChatEventActionEnum["CHAT_ATTACHMENT_DOWNLOAD"] = "CHAT_ATTACHMENT_DOWNLOAD";
    ChatEventActionEnum["CHAT_MESSAGE_POSTED"] = "CHAT_MESSAGE_POSTED";
    ChatEventActionEnum["CHAT_CONVERSATION_READ"] = "CHAT_CONVERSATION_READ";
    ChatEventActionEnum["CHAT_ROOM_LEFT"] = "CHAT_ROOM_LEFT";
    ChatEventActionEnum["CHAT_UNREAD_TIMESTAMP_UPDATED"] = "CHAT_UNREAD_TIMESTAMP_UPDATED";
    ChatEventActionEnum["CHAT_ROOM_DELETED"] = "CHAT_ROOM_DELETED";
    ChatEventActionEnum["CHAT_ATTACHMENT_UPLOAD"] = "CHAT_ATTACHMENT_UPLOAD";
    ChatEventActionEnum["CHAT_REACTION_ADDED"] = "CHAT_REACTION_ADDED";
    ChatEventActionEnum["CHAT_HISTORY_TURNED_ON"] = "CHAT_HISTORY_TURNED_ON";
    ChatEventActionEnum["CHAT_MESSAGE_DELETED"] = "CHAT_MESSAGE_DELETED";
    ChatEventActionEnum["CHAT_MESSAGE_EDITED"] = "CHAT_MESSAGE_EDITED";
    ChatEventActionEnum["CHAT_DIRECT_MESSAGE_STARTED"] = "CHAT_DIRECT_MESSAGE_STARTED";
    ChatEventActionEnum["CHAT_REACTION_REMOVED"] = "CHAT_REACTION_REMOVED";
    ChatEventActionEnum["CHAT_INVITE_ACCEPT"] = "CHAT_INVITE_ACCEPT";
    ChatEventActionEnum["CHAT_ROOM_DETAILS_UPDATED"] = "CHAT_ROOM_DETAILS_UPDATED";
    ChatEventActionEnum["CHAT_ROOM_NAME_UPDATED"] = "CHAT_ROOM_NAME_UPDATED";
    ChatEventActionEnum["CHAT_INVITE_SEND"] = "CHAT_INVITE_SEND";
    ChatEventActionEnum["CHAT_ROLE_UPDATED"] = "CHAT_ROLE_UPDATED";
})(ChatEventActionEnum || (ChatEventActionEnum = {}));
export var ExternalGoogleGeminiEventNameEnum;
(function (ExternalGoogleGeminiEventNameEnum) {
    ExternalGoogleGeminiEventNameEnum["FEATURE_UTILIZATION"] = "feature_utilization";
})(ExternalGoogleGeminiEventNameEnum || (ExternalGoogleGeminiEventNameEnum = {}));
export var GeminiEventActionEnum;
(function (GeminiEventActionEnum) {
    GeminiEventActionEnum["GEMINI_FEATURE_UTILIZATION"] = "GEMINI_FEATURE_UTILIZATION";
})(GeminiEventActionEnum || (GeminiEventActionEnum = {}));
export var GeminiActionEnum;
(function (GeminiActionEnum) {
    GeminiActionEnum["GENERATE_STARTER_TILE_PROMPTS"] = "GENERATE_STARTER_TILE_PROMPTS";
    GeminiActionEnum["SUGGEST_FULL_REPLIES"] = "SUGGEST_FULL_REPLIES";
    GeminiActionEnum["LIST_ACTION_ITEMS_REFINEMENT"] = "LIST_ACTION_ITEMS_REFINEMENT";
    GeminiActionEnum["CONDENSE"] = "CONDENSE";
    GeminiActionEnum["PARAPHRASE"] = "PARAPHRASE";
    GeminiActionEnum["GENERATE_TALKSHOW"] = "GENERATE_TALKSHOW";
    GeminiActionEnum["SUMMARIZE_PROACTIVE_SHORT"] = "SUMMARIZE_PROACTIVE_SHORT";
    GeminiActionEnum["BULLETIZE"] = "BULLETIZE";
    GeminiActionEnum["FORMALIZE"] = "FORMALIZE";
    GeminiActionEnum["SEARCH_IN_CONVERSATION"] = "SEARCH_IN_CONVERSATION";
    GeminiActionEnum["MATCH_WRITING_STYLE"] = "MATCH_WRITING_STYLE";
    GeminiActionEnum["COMMENT_CONVERSATION"] = "COMMENT_CONVERSATION";
    GeminiActionEnum["ASK_ABOUT_CONTEXT"] = "ASK_ABOUT_CONTEXT";
    GeminiActionEnum["GENERATE_IMAGE_FOR_CURRENT_PAGE"] = "GENERATE_IMAGE_FOR_CURRENT_PAGE";
    GeminiActionEnum["CONVERSATION"] = "CONVERSATION";
    GeminiActionEnum["PROACTIVE_SUGGESTIONS_RESPONSE"] = "PROACTIVE_SUGGESTIONS_RESPONSE";
    GeminiActionEnum["SUMMARIZE_PROACTIVE"] = "SUMMARIZE_PROACTIVE";
    GeminiActionEnum["GENERATE_IMAGES_IN_PRODUCT"] = "GENERATE_IMAGES_IN_PRODUCT";
    GeminiActionEnum["SUMMARIZE"] = "SUMMARIZE";
    GeminiActionEnum["GENERATE_STARTER_ACTIVE_VIEW"] = "GENERATE_STARTER_ACTIVE_VIEW";
    GeminiActionEnum["GENERATE_TEXT"] = "GENERATE_TEXT";
    GeminiActionEnum["GENERATE_DOCUMENT"] = "GENERATE_DOCUMENT";
    GeminiActionEnum["DESCRIBE_GEMINI_USES"] = "DESCRIBE_GEMINI_USES";
    GeminiActionEnum["REMOVE_BACKGROUND"] = "REMOVE_BACKGROUND";
    GeminiActionEnum["SEARCH_WEB"] = "SEARCH_WEB";
    GeminiActionEnum["SUMMARIZE_LONG"] = "SUMMARIZE_LONG";
    GeminiActionEnum["CLASSIC_USE_CASE_GEMINI"] = "CLASSIC_USE_CASE_GEMINI";
    GeminiActionEnum["PROOFREAD"] = "PROOFREAD";
    GeminiActionEnum["ELABORATE"] = "ELABORATE";
    GeminiActionEnum["SUMMARIZE_ITEMS"] = "SUMMARIZE_ITEMS";
    GeminiActionEnum["EXPAND"] = "EXPAND";
    GeminiActionEnum["CREATE_FAQ"] = "CREATE_FAQ";
    GeminiActionEnum["INFORMALIZE"] = "INFORMALIZE";
    GeminiActionEnum["ASK_ABOUT_THIS_FILE"] = "ASK_ABOUT_THIS_FILE";
    GeminiActionEnum["SUMMARIZE_UNSPECIFIED_FOLDER"] = "SUMMARIZE_UNSPECIFIED_FOLDER";
    GeminiActionEnum["SUGGEST_REPLIES"] = "SUGGEST_REPLIES";
    GeminiActionEnum["CLASSIC_USE_CASE_PROOFREAD_CONCISENESS"] = "CLASSIC_USE_CASE_PROOFREAD_CONCISENESS";
    GeminiActionEnum["GENERATE_VIDEOS_IN_PRODUCT"] = "GENERATE_VIDEOS_IN_PRODUCT";
    GeminiActionEnum["OUTLINE"] = "OUTLINE";
    GeminiActionEnum["GENERATE_BACKGROUNDS"] = "GENERATE_BACKGROUNDS";
    GeminiActionEnum["CATCH_ME_UP"] = "CATCH_ME_UP";
    GeminiActionEnum["REFINE_PHRASING"] = "REFINE_PHRASING";
    GeminiActionEnum["GENERATE_STARTER_FREEFORM"] = "GENERATE_STARTER_FREEFORM";
    GeminiActionEnum["REFINE_CONTENT"] = "REFINE_CONTENT";
    GeminiActionEnum["SUMMARIZE_FILE"] = "SUMMARIZE_FILE";
    GeminiActionEnum["REPLACE_BACKGROUND"] = "REPLACE_BACKGROUND";
    GeminiActionEnum["SUMMARIZE_UNSPECIFIED_FILE"] = "SUMMARIZE_UNSPECIFIED_FILE";
    GeminiActionEnum["OUTPAINT"] = "OUTPAINT";
    GeminiActionEnum["SUMMARIZE_CONVERSATION"] = "SUMMARIZE_CONVERSATION";
    GeminiActionEnum["AUTO_ADJUST_LAYOUT"] = "AUTO_ADJUST_LAYOUT";
    GeminiActionEnum["GENERATE_TEXT_COMPLETION"] = "GENERATE_TEXT_COMPLETION";
    GeminiActionEnum["GENERATE_AI_FUNCTION_RESPONSE"] = "GENERATE_AI_FUNCTION_RESPONSE";
    GeminiActionEnum["GENERATE_TEXT_FOR_CURRENT_PAGE"] = "GENERATE_TEXT_FOR_CURRENT_PAGE";
    GeminiActionEnum["ANALYZE_DOCUMENTS"] = "ANALYZE_DOCUMENTS";
    GeminiActionEnum["GENERATE_TITLE_FOR_CURRENT_PAGE"] = "GENERATE_TITLE_FOR_CURRENT_PAGE";
    GeminiActionEnum["GENERATE_NEXT_STEPS"] = "GENERATE_NEXT_STEPS";
    GeminiActionEnum["AUTO_PROOFREAD"] = "AUTO_PROOFREAD";
    GeminiActionEnum["CLASSIC_USE_CASE_MEET_STUDIO_LOOK"] = "CLASSIC_USE_CASE_MEET_STUDIO_LOOK";
    GeminiActionEnum["CLASSIC_USE_CASE_MEET_STUDIO_SOUND"] = "CLASSIC_USE_CASE_MEET_STUDIO_SOUND";
    GeminiActionEnum["LIST_ACTION_ITEMS"] = "LIST_ACTION_ITEMS";
    GeminiActionEnum["SUMMARIZE_EXECUTIVE_SUMMARY"] = "SUMMARIZE_EXECUTIVE_SUMMARY";
    GeminiActionEnum["PROACTIVE_SUGGESTIONS"] = "PROACTIVE_SUGGESTIONS";
    GeminiActionEnum["DETECT_SCHEDULE_INTENT"] = "DETECT_SCHEDULE_INTENT";
    GeminiActionEnum["USER_CONFIRMED_TOOLS_OPERATION"] = "USER_CONFIRMED_TOOLS_OPERATION";
    GeminiActionEnum["GENERATE_APPS_SEARCH_OVERLAY_SUGGESTIONS"] = "GENERATE_APPS_SEARCH_OVERLAY_SUGGESTIONS";
    GeminiActionEnum["SUGGEST_REPLY_PROMPTS"] = "SUGGEST_REPLY_PROMPTS";
    GeminiActionEnum["SUMMARIZE_DM"] = "SUMMARIZE_DM";
    GeminiActionEnum["SUMMARIZE_SPACE"] = "SUMMARIZE_SPACE";
    GeminiActionEnum["SUMMARIZE_THREAD"] = "SUMMARIZE_THREAD";
    GeminiActionEnum["LIST_ACTION_ITEMS_FILTERING"] = "LIST_ACTION_ITEMS_FILTERING";
    GeminiActionEnum["LIST_ACTION_ITEMS_PROACTIVE"] = "LIST_ACTION_ITEMS_PROACTIVE";
    GeminiActionEnum["GENERATE_NUDGE_PROMPTS"] = "GENERATE_NUDGE_PROMPTS";
    GeminiActionEnum["CLASSIC_USE_CASE_MEET_STUDIO_LIGHTING"] = "CLASSIC_USE_CASE_MEET_STUDIO_LIGHTING";
    GeminiActionEnum["SUMMARIZE_SNIPPET"] = "SUMMARIZE_SNIPPET";
    GeminiActionEnum["ADD_TO_CALENDAR"] = "ADD_TO_CALENDAR";
    GeminiActionEnum["LIST_ACTION_ITEMS_ANNOTATOR"] = "LIST_ACTION_ITEMS_ANNOTATOR";
    GeminiActionEnum["CLASSIC_USE_CASE_PROOFREAD_GRAMMAR"] = "CLASSIC_USE_CASE_PROOFREAD_GRAMMAR";
    GeminiActionEnum["CLASSIC_USE_CASE_PROOFREAD_SPELLING"] = "CLASSIC_USE_CASE_PROOFREAD_SPELLING";
    GeminiActionEnum["GENERATE_PAGE_OUTLINE"] = "GENERATE_PAGE_OUTLINE";
    GeminiActionEnum["GENERATE_FOLDER_SUGGESTIONS"] = "GENERATE_FOLDER_SUGGESTIONS";
    GeminiActionEnum["REFINE_FRIENDLY"] = "REFINE_FRIENDLY";
    GeminiActionEnum["SUMMARIZE_SALES_LEAD"] = "SUMMARIZE_SALES_LEAD";
    GeminiActionEnum["REFINE_ENGAGING"] = "REFINE_ENGAGING";
    GeminiActionEnum["REFINE_PERSUASIVE"] = "REFINE_PERSUASIVE";
    GeminiActionEnum["SUGGEST_REPLY_SALES"] = "SUGGEST_REPLY_SALES";
    GeminiActionEnum["TRIGGER_GOLDEN_PROMPT"] = "TRIGGER_GOLDEN_PROMPT";
    GeminiActionEnum["CUSTOM_PROMPT"] = "CUSTOM_PROMPT";
    GeminiActionEnum["SUMMARIZE_SPACE_COMPREHENSIVE"] = "SUMMARIZE_SPACE_COMPREHENSIVE";
    GeminiActionEnum["DETECT_SCHEDULE_INTENT_COMPOSE"] = "DETECT_SCHEDULE_INTENT_COMPOSE";
    GeminiActionEnum["SUMMARIZE_THREAD_COMPREHENSIVE"] = "SUMMARIZE_THREAD_COMPREHENSIVE";
    GeminiActionEnum["SEARCH_ANSWER"] = "SEARCH_ANSWER";
    GeminiActionEnum["FIND_AND_ORGANIZE_WITHIN_FOLDER"] = "FIND_AND_ORGANIZE_WITHIN_FOLDER";
    GeminiActionEnum["GENERATE_AVATAR_VIDEO"] = "GENERATE_AVATAR_VIDEO";
    GeminiActionEnum["CHIP_AGENT"] = "CHIP_AGENT";
    GeminiActionEnum["ASK_ABOUT_UNSPECIFIED_FILE"] = "ASK_ABOUT_UNSPECIFIED_FILE";
    GeminiActionEnum["EVALUATE_NATURAL_LANGUAGE_CONDITION"] = "EVALUATE_NATURAL_LANGUAGE_CONDITION";
    GeminiActionEnum["BRIEF"] = "BRIEF";
    GeminiActionEnum["GENERATE_AI_FUNCTION_RESPONSE_IN_BATCH"] = "GENERATE_AI_FUNCTION_RESPONSE_IN_BATCH";
    GeminiActionEnum["SUGGEST_TIME"] = "SUGGEST_TIME";
    GeminiActionEnum["CATEGORIZE_CONTENT"] = "CATEGORIZE_CONTENT";
    GeminiActionEnum["FIND_AND_ORGANIZE_ITEMS_TO_LOCATION"] = "FIND_AND_ORGANIZE_ITEMS_TO_LOCATION";
    GeminiActionEnum["COMPARE_UNSPECIFIED_FILES"] = "COMPARE_UNSPECIFIED_FILES";
    GeminiActionEnum["DESCRIBE_IMAGE"] = "DESCRIBE_IMAGE";
    GeminiActionEnum["SUGGEST_PROMPTS"] = "SUGGEST_PROMPTS";
    GeminiActionEnum["REPORT_UNSPECIFIED_FILES"] = "REPORT_UNSPECIFIED_FILES";
    GeminiActionEnum["CLASSIC_USE_CASE_PRESET_VOICEOVER"] = "CLASSIC_USE_CASE_PRESET_VOICEOVER";
    GeminiActionEnum["CLASSIC_USE_CASE_SHEETS_TURBOFILL"] = "CLASSIC_USE_CASE_SHEETS_TURBOFILL";
    GeminiActionEnum["GENERATE_FORM"] = "GENERATE_FORM";
    GeminiActionEnum["CLASSIC_USE_CASE_PROOFREAD_SENTENCE_SPLITTING"] = "CLASSIC_USE_CASE_PROOFREAD_SENTENCE_SPLITTING";
    GeminiActionEnum["CLASSIC_USE_CASE_PROOFREAD_WORD_CHOICE"] = "CLASSIC_USE_CASE_PROOFREAD_WORD_CHOICE";
    GeminiActionEnum["CLASSIC_USE_CASE_PROOFREAD_ACTIVE_VOICE"] = "CLASSIC_USE_CASE_PROOFREAD_ACTIVE_VOICE";
    GeminiActionEnum["CLASSIC_USE_CASE_TELEPROMPTER_WORD_MATCH"] = "CLASSIC_USE_CASE_TELEPROMPTER_WORD_MATCH";
    GeminiActionEnum["GENERATE_FORM_QUESTIONS"] = "GENERATE_FORM_QUESTIONS";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_QUESTIONS"] = "CLASSIC_USE_CASE_GENERATE_QUESTIONS";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_RUBRIC"] = "CLASSIC_USE_CASE_GENERATE_RUBRIC";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_VOCAB_LIST"] = "CLASSIC_USE_CASE_GENERATE_VOCAB_LIST";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_LESSON_PLAN"] = "CLASSIC_USE_CASE_GENERATE_LESSON_PLAN";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_CHOICE_BOARD"] = "CLASSIC_USE_CASE_GENERATE_CHOICE_BOARD";
    GeminiActionEnum["CLASSIC_USE_CASE_RELEVEL_CONTENT"] = "CLASSIC_USE_CASE_RELEVEL_CONTENT";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_STORY"] = "CLASSIC_USE_CASE_GENERATE_STORY";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_TEXT_DEPENDENT_QUESTIONS"] = "CLASSIC_USE_CASE_GENERATE_TEXT_DEPENDENT_QUESTIONS";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_COMMON_MISCONCEPTIONS"] = "CLASSIC_USE_CASE_GENERATE_COMMON_MISCONCEPTIONS";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_HOOKS"] = "CLASSIC_USE_CASE_GENERATE_HOOKS";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_PROJECT_ACTIVITIES"] = "CLASSIC_USE_CASE_GENERATE_PROJECT_ACTIVITIES";
    GeminiActionEnum["CLASSIC_USE_CASE_GENERATE_INFORMATIVE_ARTICLES"] = "CLASSIC_USE_CASE_GENERATE_INFORMATIVE_ARTICLES";
})(GeminiActionEnum || (GeminiActionEnum = {}));
export var GeminiAppNameEnum;
(function (GeminiAppNameEnum) {
    GeminiAppNameEnum["GEMINI_APP"] = "GEMINI_APP";
    GeminiAppNameEnum["CHAT"] = "CHAT";
    GeminiAppNameEnum["CLASSROOM"] = "CLASSROOM";
    GeminiAppNameEnum["DOCS"] = "DOCS";
    GeminiAppNameEnum["DRIVE"] = "DRIVE";
    GeminiAppNameEnum["GMAIL"] = "GMAIL";
    GeminiAppNameEnum["KEEP"] = "KEEP";
    GeminiAppNameEnum["MEET"] = "MEET";
    GeminiAppNameEnum["SHEETS"] = "SHEETS";
    GeminiAppNameEnum["SLIDES"] = "SLIDES";
    GeminiAppNameEnum["VIDS"] = "VIDS";
})(GeminiAppNameEnum || (GeminiAppNameEnum = {}));
export var GeminiEventCategoryEnum;
(function (GeminiEventCategoryEnum) {
    GeminiEventCategoryEnum["ACTIVE_CONVERSATIONS"] = "ACTIVE_CONVERSATIONS";
    GeminiEventCategoryEnum["ACTIVE_GENERATE"] = "ACTIVE_GENERATE";
    GeminiEventCategoryEnum["ACTIVE_SUMMARIZE"] = "ACTIVE_SUMMARIZE";
    GeminiEventCategoryEnum["ACTIVE_UNSPECIFIED"] = "ACTIVE_UNSPECIFIED";
    GeminiEventCategoryEnum["INACTIVE"] = "INACTIVE";
    GeminiEventCategoryEnum["UNKNOWN"] = "UNKNOWN";
})(GeminiEventCategoryEnum || (GeminiEventCategoryEnum = {}));
// INACTIVE and UNKNOWN are system-level noise from Google, not real user activity:
// they are dropped on ingestion and excluded from every Gemini usage metric.
export var GEMINI_COUNTED_EVENT_CATEGORIES = [
    GeminiEventCategoryEnum.ACTIVE_CONVERSATIONS,
    GeminiEventCategoryEnum.ACTIVE_GENERATE,
    GeminiEventCategoryEnum.ACTIVE_SUMMARIZE,
    GeminiEventCategoryEnum.ACTIVE_UNSPECIFIED
];
export var isGeminiCountedEventCategory = function (value) {
    return GEMINI_COUNTED_EVENT_CATEGORIES.includes(value);
};
export var GeminiUsageCategoryEnum;
(function (GeminiUsageCategoryEnum) {
    GeminiUsageCategoryEnum["CHAT_AND_RESEARCH"] = "CHAT_AND_RESEARCH";
    GeminiUsageCategoryEnum["CONTENT_CREATION"] = "CONTENT_CREATION";
    GeminiUsageCategoryEnum["SUMMARIZE"] = "SUMMARIZE";
    GeminiUsageCategoryEnum["WORKFLOW_ACTIONS"] = "WORKFLOW_ACTIONS";
})(GeminiUsageCategoryEnum || (GeminiUsageCategoryEnum = {}));
export var GeminiGroupedChartViewEnum;
(function (GeminiGroupedChartViewEnum) {
    GeminiGroupedChartViewEnum["TEAM"] = "TEAM";
    GeminiGroupedChartViewEnum["USER"] = "USER";
    GeminiGroupedChartViewEnum["PERIOD"] = "PERIOD";
})(GeminiGroupedChartViewEnum || (GeminiGroupedChartViewEnum = {}));
export var GEMINI_EVENT_CATEGORY_TO_USAGE_CATEGORY = (_b = {},
    _b[GeminiEventCategoryEnum.ACTIVE_CONVERSATIONS] = GeminiUsageCategoryEnum.CHAT_AND_RESEARCH,
    _b[GeminiEventCategoryEnum.ACTIVE_GENERATE] = GeminiUsageCategoryEnum.CONTENT_CREATION,
    _b[GeminiEventCategoryEnum.ACTIVE_SUMMARIZE] = GeminiUsageCategoryEnum.SUMMARIZE,
    _b[GeminiEventCategoryEnum.ACTIVE_UNSPECIFIED] = GeminiUsageCategoryEnum.WORKFLOW_ACTIONS,
    _b);
export var GEMINI_USAGE_CATEGORIES = [
    GeminiUsageCategoryEnum.CHAT_AND_RESEARCH,
    GeminiUsageCategoryEnum.CONTENT_CREATION,
    GeminiUsageCategoryEnum.SUMMARIZE,
    GeminiUsageCategoryEnum.WORKFLOW_ACTIONS
];
export var GeminiUsageLevelEnum;
(function (GeminiUsageLevelEnum) {
    GeminiUsageLevelEnum["ZERO"] = "ZERO";
    GeminiUsageLevelEnum["LOW"] = "LOW";
    GeminiUsageLevelEnum["MEDIUM"] = "MEDIUM";
    GeminiUsageLevelEnum["HIGH"] = "HIGH";
})(GeminiUsageLevelEnum || (GeminiUsageLevelEnum = {}));
export var GeminiFeatureSourceEnum;
(function (GeminiFeatureSourceEnum) {
    GeminiFeatureSourceEnum["ADAPTIVE_AUDIO"] = "ADAPTIVE_AUDIO";
    GeminiFeatureSourceEnum["CHAT_WITH_GEMINI"] = "CHAT_WITH_GEMINI";
    GeminiFeatureSourceEnum["CLASSROOM_GEMINI_EDUCATION"] = "CLASSROOM_GEMINI_EDUCATION";
    GeminiFeatureSourceEnum["CONVERSATION_SUMMARIES"] = "CONVERSATION_SUMMARIES";
    GeminiFeatureSourceEnum["ENHANCED_SMART_FILL"] = "ENHANCED_SMART_FILL";
    GeminiFeatureSourceEnum["GENERATE_BACKGROUND"] = "GENERATE_BACKGROUND";
    GeminiFeatureSourceEnum["HELP_ME_ORGANIZE"] = "HELP_ME_ORGANIZE";
    GeminiFeatureSourceEnum["HELP_ME_REFINE"] = "HELP_ME_REFINE";
    GeminiFeatureSourceEnum["HELP_ME_VISUALIZE"] = "HELP_ME_VISUALIZE";
    GeminiFeatureSourceEnum["HELP_ME_WRITE"] = "HELP_ME_WRITE";
    GeminiFeatureSourceEnum["PROOFREAD"] = "PROOFREAD";
    GeminiFeatureSourceEnum["REMOVE_IMAGE_BACKGROUND"] = "REMOVE_IMAGE_BACKGROUND";
    GeminiFeatureSourceEnum["SIDE_PANEL"] = "SIDE_PANEL";
    GeminiFeatureSourceEnum["STUDIO_LIGHT"] = "STUDIO_LIGHT";
    GeminiFeatureSourceEnum["STUDIO_LOOK"] = "STUDIO_LOOK";
    GeminiFeatureSourceEnum["STUDIO_SOUND"] = "STUDIO_SOUND";
    GeminiFeatureSourceEnum["WORKFLOWS_CREATION"] = "WORKFLOWS_CREATION";
    GeminiFeatureSourceEnum["WORKFLOWS_EXECUTION"] = "WORKFLOWS_EXECUTION";
})(GeminiFeatureSourceEnum || (GeminiFeatureSourceEnum = {}));
export var EditDocumentAlertExceptEnum;
(function (EditDocumentAlertExceptEnum) {
    EditDocumentAlertExceptEnum["OWNER"] = "OWNER";
})(EditDocumentAlertExceptEnum || (EditDocumentAlertExceptEnum = {}));
export var OnboardingSteps;
(function (OnboardingSteps) {
    OnboardingSteps[OnboardingSteps["firstStep"] = 1] = "firstStep";
    OnboardingSteps[OnboardingSteps["secondStep"] = 2] = "secondStep";
    OnboardingSteps[OnboardingSteps["thirdStep"] = 3] = "thirdStep";
})(OnboardingSteps || (OnboardingSteps = {}));
export var UserRoles;
(function (UserRoles) {
    UserRoles["MANAGER"] = "MANAGER";
    UserRoles["USER"] = "USER";
    UserRoles["ADMIN"] = "ADMIN";
})(UserRoles || (UserRoles = {}));
export var InsightTypeEnum;
(function (InsightTypeEnum) {
    InsightTypeEnum["data"] = "data";
    InsightTypeEnum["timeSpentOnWorkActivities"] = "timeSpentOnWorkActivities";
    InsightTypeEnum["timeSpentByActivityType"] = "timeSpentByActivityType";
    InsightTypeEnum["gmailActivity"] = "gmailActivity";
    InsightTypeEnum["gmailActionsOverTime"] = "gmailActionsOverTime";
    InsightTypeEnum["gmailSummary"] = "gmailSummary";
    InsightTypeEnum["driveSummary"] = "driveSummary";
    InsightTypeEnum["driveActionsOverTime"] = "driveActionsOverTime";
    InsightTypeEnum["driveDocumentsActivity"] = "driveDocumentsActivity";
    InsightTypeEnum["driveActivity"] = "driveActivity";
    InsightTypeEnum["meetActivity"] = "meetActivity";
    InsightTypeEnum["meetingLoadAnalytic"] = "meetingLoadAnalytic";
    InsightTypeEnum["meetingsBySizeAnalytic"] = "meetingsBySizeAnalytic";
    InsightTypeEnum["meetingsByLengthAnalytic"] = "meetingsByLengthAnalytic";
    InsightTypeEnum["meetingsByScheduleAnalytic"] = "meetingsByScheduleAnalytic";
    InsightTypeEnum["meetingsBackToBackAnalytic"] = "meetingsBackToBackAnalytic";
    InsightTypeEnum["meetingsByWhenAnalytic"] = "meetingsByWhenAnalytic";
    InsightTypeEnum["meetingsByWhoAttendedAnalytic"] = "meetingsByWhoAttendedAnalytic";
    InsightTypeEnum["meetingsPlannedVsActualAnalytic"] = "meetingsPlannedVsActualAnalytic";
    InsightTypeEnum["meetSummary"] = "meetSummary";
    InsightTypeEnum["chatActivity"] = "chatActivity";
    InsightTypeEnum["chatSummary"] = "chatSummary";
    InsightTypeEnum["chatActivityBreakdown"] = "chatActivityBreakdown";
    InsightTypeEnum["activitySummaryHeatmap"] = "activitySummaryHeatmap";
    InsightTypeEnum["chatChart"] = "chatChart";
    InsightTypeEnum["documentReport"] = "documentReport";
    InsightTypeEnum["dailyTimeline"] = "dailyTimeline";
    InsightTypeEnum["userHeatmap"] = "userHeatmap";
    InsightTypeEnum["userDriveActivity"] = "userDriveActivity";
    InsightTypeEnum["meetingsTypes"] = "meetingsTypes";
    InsightTypeEnum["docAlertsTable"] = "docAlertsTable";
    InsightTypeEnum["docAlertsChart"] = "docAlertsChart";
    InsightTypeEnum["eventsTable"] = "eventsTable";
    InsightTypeEnum["documentActivity"] = "documentActivity";
    InsightTypeEnum["documentDailyTimeline"] = "documentDailyTimeline";
    InsightTypeEnum["documentEventsLog"] = "documentEventsLog";
    InsightTypeEnum["documentPeopleActivity"] = "documentPeopleActivity";
    InsightTypeEnum["documentFileSummary"] = "documentFileSummary";
    InsightTypeEnum["meetUsersTimeline"] = "meetUsersTimeline";
    InsightTypeEnum["meetSummaryTable"] = "meetSummaryTable";
    InsightTypeEnum["createdItemsByType"] = "createdItemsByType";
    InsightTypeEnum["mostPopularDocuments"] = "mostPopularDocuments";
    InsightTypeEnum["createdItemsByActivityLabel"] = "createdItemsByActivityLabel";
    InsightTypeEnum["topRecurringEventsAndMeetings"] = "topRecurringEventsAndMeetings";
    InsightTypeEnum["userActivityOnResolving"] = "userActivityOnResolving";
    InsightTypeEnum["docReviewCount"] = "docReviewCount";
    InsightTypeEnum["userInitiatedCommunication"] = "userInitiatedCommunication";
    InsightTypeEnum["userReceivedCommunication"] = "userReceivedCommunication";
    InsightTypeEnum["emailSummaryReplyRate"] = "emailSummaryReplyRate";
    InsightTypeEnum["sentVsReceivedEmailsAndChatsRatio"] = "sentVsReceivedEmailsAndChatsRatio";
    InsightTypeEnum["communicationByActivityLabel"] = "communicationByActivityLabel";
    InsightTypeEnum["communicationByPeerType"] = "communicationByPeerType";
    InsightTypeEnum["employeeMeetingsByTimePeriod"] = "employeeMeetingsByTimePeriod";
    InsightTypeEnum["mostFrequentCommunicationPartners"] = "mostFrequentCommunicationPartners";
    InsightTypeEnum["communicationDistributionByWeekdays"] = "communicationDistributionByWeekdays";
    InsightTypeEnum["chatRoomsByMessageVolume"] = "chatRoomsByMessageVolume";
    InsightTypeEnum["topChatters"] = "topChatters";
    InsightTypeEnum["collaborativeTime"] = "collaborativeTime";
    InsightTypeEnum["chatResponseSpeedAndFrequency"] = "chatResponseSpeedAndFrequency";
    InsightTypeEnum["emailResponseSpeedAndFrequency"] = "emailResponseSpeedAndFrequency";
    InsightTypeEnum["consistencyOfAttendanceInMeets"] = "consistencyOfAttendanceInMeets";
    InsightTypeEnum["scheduledMeetAttendanceRate"] = "scheduledMeetAttendanceRate";
    InsightTypeEnum["workdayAlignmentWithTeam"] = "workdayAlignmentWithTeam";
    InsightTypeEnum["plannedVSAdHocMeetings"] = "plannedVSAdHocMeetings";
    InsightTypeEnum["createdAndOwnedFiles"] = "createdAndOwnedFiles";
    InsightTypeEnum["filesSharedByEmployee"] = "filesSharedByEmployee";
    InsightTypeEnum["timeSpentOnIndependentWorkActivities"] = "timeSpentOnIndependentWorkActivities";
    InsightTypeEnum["breaksDuringWorkIndicator"] = "breaksDuringWorkIndicator";
    InsightTypeEnum["daysWithExtendedWorkHours"] = "daysWithExtendedWorkHours";
    InsightTypeEnum["docsSharedExternally"] = "docsSharedExternally";
    InsightTypeEnum["docsSharedExternallyByLabel"] = "docsSharedExternallyByLabel";
    InsightTypeEnum["managerIndividualCommTime"] = "managerIndividualCommTime";
    InsightTypeEnum["geminiSummary"] = "geminiSummary";
    InsightTypeEnum["geminiUserSummary"] = "geminiUserSummary";
    InsightTypeEnum["geminiAdoptionTrend"] = "geminiAdoptionTrend";
    InsightTypeEnum["geminiUsageLevelDistribution"] = "geminiUsageLevelDistribution";
    InsightTypeEnum["geminiUsageCategoryByApp"] = "geminiUsageCategoryByApp";
    InsightTypeEnum["geminiActionBreakdown"] = "geminiActionBreakdown";
    InsightTypeEnum["invocationsByApp"] = "invocationsByApp";
    InsightTypeEnum["invocationsByAction"] = "invocationsByAction";
    InsightTypeEnum["invocationsByUser"] = "invocationsByUser";
    InsightTypeEnum["workingTimeAllocationByLabel"] = "workingTimeAllocationByLabel";
    InsightTypeEnum["workLocationBreakdown"] = "workLocationBreakdown";
})(InsightTypeEnum || (InsightTypeEnum = {}));
export var drivePeopleActivityFields;
(function (drivePeopleActivityFields) {
    drivePeopleActivityFields["views"] = "views";
    drivePeopleActivityFields["edits"] = "edits";
    drivePeopleActivityFields["downloads"] = "downloads";
    drivePeopleActivityFields["prints"] = "prints";
    drivePeopleActivityFields["commentsPosted"] = "commentsPosted";
    drivePeopleActivityFields["commentsResolved"] = "commentsResolved";
    drivePeopleActivityFields["suggestionsPosted"] = "suggestionsPosted";
    drivePeopleActivityFields["suggestionsResolved"] = "suggestionsResolved";
    drivePeopleActivityFields["sharedInternally"] = "sharedInternally";
    drivePeopleActivityFields["sharedExternally"] = "sharedExternally";
    drivePeopleActivityFields["sharedPublicly"] = "sharedPublicly";
})(drivePeopleActivityFields || (drivePeopleActivityFields = {}));
export var MeetType;
(function (MeetType) {
    MeetType["Unscheduled"] = "Unscheduled";
    MeetType["Scheduled"] = "Scheduled";
    MeetType["Recurring"] = "Recurring";
})(MeetType || (MeetType = {}));
export var MeetTimelineEventEnum;
(function (MeetTimelineEventEnum) {
    MeetTimelineEventEnum["MEET_CALL_STARTED"] = "MEET_CALL_STARTED";
})(MeetTimelineEventEnum || (MeetTimelineEventEnum = {}));
export var OrgUnitTypeEnum;
(function (OrgUnitTypeEnum) {
    OrgUnitTypeEnum["GOOGLE"] = "GOOGLE";
    OrgUnitTypeEnum["DEFAULT"] = "DEFAULT";
})(OrgUnitTypeEnum || (OrgUnitTypeEnum = {}));
export var ScopeUIFilterEnum;
(function (ScopeUIFilterEnum) {
    ScopeUIFilterEnum["FILTER_ORG_UNIT"] = "filter:orgUnit";
    ScopeUIFilterEnum["FILTER_USER"] = "filter:user";
})(ScopeUIFilterEnum || (ScopeUIFilterEnum = {}));
export var ScopeUIPageEnum;
(function (ScopeUIPageEnum) {
    ScopeUIPageEnum["PAGE_DOC_ALERTS"] = "page:docAlerts";
    ScopeUIPageEnum["PAGE_SETTINGS"] = "page:settings";
})(ScopeUIPageEnum || (ScopeUIPageEnum = {}));
export var ScopeApiOrgUnitEnum;
(function (ScopeApiOrgUnitEnum) {
    ScopeApiOrgUnitEnum["API_ORG_UNITS_GET_ALL"] = "api:orgUnits:get:all";
    ScopeApiOrgUnitEnum["API_ORG_UNITS_GET_ONLY_MY_ORG_UNITS"] = "api:orgUnits:get:onlyMyOrgUnits";
})(ScopeApiOrgUnitEnum || (ScopeApiOrgUnitEnum = {}));
export var ScopeApiUserEnum;
(function (ScopeApiUserEnum) {
    ScopeApiUserEnum["API_USERS_GET_ALL"] = "api:users:get:all";
    ScopeApiUserEnum["API_USERS_GET_ONLY_IN_MY_ORG_UNITS"] = "api:users:get:onlyInMyOrgUnits";
    ScopeApiUserEnum["API_USERS_GET_ONLY_SELF"] = "api:users:get:onlySelf";
    ScopeApiUserEnum["API_ALERTS_GET_ALL"] = "api:alerts:get:all";
})(ScopeApiUserEnum || (ScopeApiUserEnum = {}));
export var OrderSubscriptionStatusEnum;
(function (OrderSubscriptionStatusEnum) {
    OrderSubscriptionStatusEnum["ACTIVE"] = "ACTIVE";
    OrderSubscriptionStatusEnum["SUSPENDED"] = "SUSPENDED";
    OrderSubscriptionStatusEnum["TERMINATED"] = "TERMINATED";
    OrderSubscriptionStatusEnum["FINISHED"] = "FINISHED";
})(OrderSubscriptionStatusEnum || (OrderSubscriptionStatusEnum = {}));
export var PaymentStatusEnum;
(function (PaymentStatusEnum) {
    PaymentStatusEnum["ORDER_CHARGED"] = "ORDER_CHARGED";
    PaymentStatusEnum["SUBSCRIPTION_CHARGE_SUCCEED"] = "SUBSCRIPTION_CHARGE_SUCCEED";
    PaymentStatusEnum["SUBSCRIPTION_CHARGE_FAILED"] = "SUBSCRIPTION_CHARGE_FAILED";
    PaymentStatusEnum["SUBSCRIPTION_SUSPENDED"] = "SUBSCRIPTION_SUSPENDED";
    PaymentStatusEnum["SUBSCRIPTION_RENEWED"] = "SUBSCRIPTION_RENEWED";
    PaymentStatusEnum["SUBSCRIPTION_TERMINATED"] = "SUBSCRIPTION_TERMINATED";
    PaymentStatusEnum["SUBSCRIPTION_FINISHED"] = "SUBSCRIPTION_FINISHED";
    PaymentStatusEnum["SUBSCRIPTION_PAYMENT_INFO_CHANGED"] = "SUBSCRIPTION_PAYMENT_INFO_CHANGED";
    PaymentStatusEnum["TRIAL_CHARGE"] = "TRIAL_CHARGE";
})(PaymentStatusEnum || (PaymentStatusEnum = {}));
export var EventSourceEnum;
(function (EventSourceEnum) {
    EventSourceEnum["GOOGLE_WEBHOOK"] = "googleWebhook";
    EventSourceEnum["PAYPRO_WEBHOOK"] = "payproWebhook";
})(EventSourceEnum || (EventSourceEnum = {}));
export var ActivityLabelTargetEnum;
(function (ActivityLabelTargetEnum) {
    ActivityLabelTargetEnum["ALL"] = "all";
    ActivityLabelTargetEnum["DOCUMENT_TITLES"] = "documentTitles";
    ActivityLabelTargetEnum["CHAT_ROOM_NAMES"] = "chatRoomNames";
    ActivityLabelTargetEnum["EVENT_NAMES"] = "eventNames";
    ActivityLabelTargetEnum["MEETING_TITLES"] = "meetingTitles";
})(ActivityLabelTargetEnum || (ActivityLabelTargetEnum = {}));
export var ActivityLabelConditionTypeEnum;
(function (ActivityLabelConditionTypeEnum) {
    ActivityLabelConditionTypeEnum["CONTAINS"] = "contains";
    ActivityLabelConditionTypeEnum["STARTS_WITH"] = "startsWith";
    ActivityLabelConditionTypeEnum["DOES_NOT_CONTAIN"] = "doesNotContain";
})(ActivityLabelConditionTypeEnum || (ActivityLabelConditionTypeEnum = {}));
export var PayProCustomFieldEnum;
(function (PayProCustomFieldEnum) {
    PayProCustomFieldEnum["WORKSPACE_ID"] = "x-workspace-id";
    PayProCustomFieldEnum["QUANTITY"] = "x-quantity";
    PayProCustomFieldEnum["SUBSCRIPTION_PLAN_ID"] = "x-subscription-plan-id";
})(PayProCustomFieldEnum || (PayProCustomFieldEnum = {}));
export var LabelFilterFieldNames;
(function (LabelFilterFieldNames) {
    LabelFilterFieldNames["TITLE"] = "title";
})(LabelFilterFieldNames || (LabelFilterFieldNames = {}));
export var PerformanceReviewSectionsEnum;
(function (PerformanceReviewSectionsEnum) {
    //TODO: Add back the sections when we have the data
    PerformanceReviewSectionsEnum["OVERVIEW"] = "overview";
    PerformanceReviewSectionsEnum["COMMUNICATION"] = "communication";
    // ACTIVITY_BY_APP = 'activityByApp',
    // TECHNICAL_SKILLS = 'technicalSkills',
    PerformanceReviewSectionsEnum["INITIATIVE_AND_OWNERSHIP"] = "initiativeAndOwnership";
    PerformanceReviewSectionsEnum["SCHEDULE_AND_ATTENDANCE"] = "scheduleAndAttendance";
    PerformanceReviewSectionsEnum["TIME_MANAGEMENT"] = "timeManagement";
    // QUALITY_OF_WORK = 'qualityOfWork',
    // WORK_CONSISTENCY = 'workConsistency',
    // WORK_LOCATION = 'workLocation',
    // INDEPENDENT_WORK = 'independentWork',
    // GROUP_WORK_AND_COLLABORATION = 'groupWorkAndCollaboration',
    // SIGNS_OF_ISOLATION = 'signsOfIsolation',
    // SIGNS_OF_BURN_OUT = 'signsOfBurnOut',
    PerformanceReviewSectionsEnum["WORK_LIFE_BALANCE"] = "workLifeBalance";
    PerformanceReviewSectionsEnum["POLICY_COMPLIANCE"] = "policyCompliance";
    PerformanceReviewSectionsEnum["AI_ADOPTION_AND_USAGE"] = "aiAdoptionAndUsage";
    PerformanceReviewSectionsEnum["DAILY_TIMELINE"] = "dailyTimeline";
    PerformanceReviewSectionsEnum["MANAGER_ONLY"] = "managerOnly";
})(PerformanceReviewSectionsEnum || (PerformanceReviewSectionsEnum = {}));
export var InitiatedCommunicationByChannel;
(function (InitiatedCommunicationByChannel) {
    InitiatedCommunicationByChannel["EMAILS_SENT"] = "emails_sent";
    InitiatedCommunicationByChannel["CHATS_MESSAGES_POSTED"] = "chats_messages_posted";
    InitiatedCommunicationByChannel["CHATS_MESSAGES_REACTIONS"] = "chats_messages_reactions";
    InitiatedCommunicationByChannel["DOCS_COMMENTS_ADDED"] = "docs_comments_added";
    InitiatedCommunicationByChannel["MEETINGS_ORGANIZED"] = "meetings_organized";
})(InitiatedCommunicationByChannel || (InitiatedCommunicationByChannel = {}));
export var ReceivedCommunicationByChannel;
(function (ReceivedCommunicationByChannel) {
    ReceivedCommunicationByChannel["EMAILS_RECEIVED"] = "emails_received";
    ReceivedCommunicationByChannel["CHATS_MESSAGES_RECEIVED"] = "chats_messages_received";
    ReceivedCommunicationByChannel["CHATS_REACTIONS_RECEIVED"] = "chats_reactions_received";
    ReceivedCommunicationByChannel["DOCS_COMMENTS_RECEIVED"] = "docs_comments_received";
    ReceivedCommunicationByChannel["MEETINGS_PARTICIPATED"] = "meetings_participated";
})(ReceivedCommunicationByChannel || (ReceivedCommunicationByChannel = {}));
export var SubscriptionToEventStatusEnum;
(function (SubscriptionToEventStatusEnum) {
    SubscriptionToEventStatusEnum["SUBSCRIBED_SUCCESS"] = "SUBSCRIBED_SUCCESS";
    SubscriptionToEventStatusEnum["SUBSCRIBED_FAILED"] = "SUBSCRIBED_FAILED";
})(SubscriptionToEventStatusEnum || (SubscriptionToEventStatusEnum = {}));
export var PeerTypeEnum;
(function (PeerTypeEnum) {
    PeerTypeEnum["TEAM_INTERNAL"] = "Team Internal";
    PeerTypeEnum["OTHER_TEAMS"] = "Other Teams";
    PeerTypeEnum["MANAGER"] = "Manager";
    PeerTypeEnum["EXTERNAL"] = "External";
})(PeerTypeEnum || (PeerTypeEnum = {}));
export var ItemsByType;
(function (ItemsByType) {
    ItemsByType["MEETINGS"] = "Meetings";
    ItemsByType["DOCUMENTS"] = "Documents";
    ItemsByType["CALENDAR_EVENTS"] = "Calendar Events";
    ItemsByType["CHAT_ROOMS"] = "Chat Rooms";
})(ItemsByType || (ItemsByType = {}));
export var SettingsTabsEnum;
(function (SettingsTabsEnum) {
    SettingsTabsEnum["GENERAL"] = "general";
    SettingsTabsEnum["USERS"] = "users";
    SettingsTabsEnum["BILLING"] = "billing";
    SettingsTabsEnum["ACTIVITY_LABELS"] = "activity-labels";
})(SettingsTabsEnum || (SettingsTabsEnum = {}));
export var WorkLocationEnum;
(function (WorkLocationEnum) {
    WorkLocationEnum["OFFICE"] = "office";
    WorkLocationEnum["REMOTE"] = "remote";
})(WorkLocationEnum || (WorkLocationEnum = {}));
export var MEETING_LOAD_KEYS = [
    'meetingCount',
    'durationSeconds',
    'manHoursSeconds',
    'avgParticipants'
];
export var MEETING_LOAD_USER_KEYS = [
    'meetingCount',
    'durationSeconds'
];
export var emptyMeetingLoadRawCounts = function () { return ({
    meetingCount: 0,
    durationSeconds: 0,
    manHoursSeconds: 0,
    participantsSum: 0
}); };
export var avgParticipantsFromRaw = function (raw) {
    if (raw.meetingCount <= 0) {
        return 0;
    }
    return Math.round((raw.participantsSum / raw.meetingCount) * 10) / 10;
};
export var MEETINGS_BY_SIZE_KEYS = [
    'oneToOne',
    'smallGroup',
    'largeGroup',
    'veryLarge'
];
/** Map guest count → size bucket. Large = 5–9; very large = 10+. */
export var meetingsBySizeKeyFromParticipantCount = function (participantCount) {
    if (participantCount <= 2) {
        return 'oneToOne';
    }
    if (participantCount <= 4) {
        return 'smallGroup';
    }
    if (participantCount <= 9) {
        return 'largeGroup';
    }
    return 'veryLarge';
};
export var emptyMeetingsBySizeRawCounts = function () { return ({
    oneToOne: emptyMeetingLoadRawCounts(),
    smallGroup: emptyMeetingLoadRawCounts(),
    largeGroup: emptyMeetingLoadRawCounts(),
    veryLarge: emptyMeetingLoadRawCounts()
}); };
export var MEETINGS_BY_LENGTH_KEYS = [
    'short',
    'medium',
    'long',
    'veryLong'
];
var SECONDS_15_MIN = 15 * 60;
var SECONDS_30_MIN = 30 * 60;
var SECONDS_60_MIN = 60 * 60;
/** Map meeting duration → length bucket. Short <15m; medium 15–30m; long 30–60m; very long 60m+. */
export var meetingsByLengthKeyFromDurationSeconds = function (durationSeconds) {
    if (durationSeconds < SECONDS_15_MIN) {
        return 'short';
    }
    if (durationSeconds < SECONDS_30_MIN) {
        return 'medium';
    }
    if (durationSeconds < SECONDS_60_MIN) {
        return 'long';
    }
    return 'veryLong';
};
export var emptyMeetingsByLengthRawCounts = function () { return ({
    short: emptyMeetingLoadRawCounts(),
    medium: emptyMeetingLoadRawCounts(),
    long: emptyMeetingLoadRawCounts(),
    veryLong: emptyMeetingLoadRawCounts()
}); };
export var MEETINGS_BY_SCHEDULE_KEYS = [
    'recurring',
    'adhoc',
    'scheduled'
];
/**
 * Map meeting calendar linkage → schedule bucket.
 * Ad-hoc = no calendar; recurring = calendar.isRecurring; scheduled = calendar one-off.
 */
export var meetingsByScheduleKeyFromMeeting = function (_a) {
    var calendarId = _a.calendarId, isRecurring = _a.isRecurring;
    if (calendarId == null) {
        return 'adhoc';
    }
    if (isRecurring) {
        return 'recurring';
    }
    return 'scheduled';
};
export var emptyMeetingsByScheduleRawCounts = function () { return ({
    recurring: emptyMeetingLoadRawCounts(),
    adhoc: emptyMeetingLoadRawCounts(),
    scheduled: emptyMeetingLoadRawCounts()
}); };
/** Max idle time between meetings (prev end → next start) to count as back-to-back. */
export var BACK_TO_BACK_MAX_GAP_SECONDS = 15 * 60;
export var MEETINGS_BACK_TO_BACK_KEYS = ['twoInARow', 'threeInARow'];
export var meetingsBackToBackKeyFromStreakLength = function (streakLength) {
    if (streakLength >= 3) {
        return 'threeInARow';
    }
    if (streakLength === 2) {
        return 'twoInARow';
    }
    return null;
};
export var emptyMeetingsBackToBackRawCounts = function () { return ({
    twoInARow: emptyMeetingLoadRawCounts(),
    threeInARow: emptyMeetingLoadRawCounts()
}); };
/**
 * Meetings classified by local start time vs workspace work hours
 * (`workspace.startWorkingHour`–`workspace.endWorkingHour`). Early / late are
 * the first and last 2 hours of that window (overlapping work-hours).
 */
export var MEETINGS_BY_WHEN_KEYS = [
    'workHours',
    'afterHours',
    'earlyMorning',
    'lateEvening'
];
/** Width of the early-morning / late-evening windows inside work hours. */
export var MEETINGS_BY_WHEN_EDGE_WINDOW_HOURS = 2;
export var emptyMeetingsByWhenRawCounts = function () { return ({
    workHours: emptyMeetingLoadRawCounts(),
    afterHours: emptyMeetingLoadRawCounts(),
    earlyMorning: emptyMeetingLoadRawCounts(),
    lateEvening: emptyMeetingLoadRawCounts()
}); };
/** Planned vs actual duration delta threshold (±30 minutes). */
export var MEETINGS_PLANNED_VS_ACTUAL_THRESHOLD_SECONDS = 30 * 60;
export var MEETINGS_PLANNED_VS_ACTUAL_KEYS = [
    'overrun',
    'underrun',
    'onTime'
];
/**
 * Map actual − planned duration (seconds) → planned-vs-actual bucket.
 * Overrun / underrun: |delta| ≥ 30m; on time: within ±30m.
 */
export var meetingsPlannedVsActualKeyFromDeltaSeconds = function (deltaSeconds) {
    if (deltaSeconds >= MEETINGS_PLANNED_VS_ACTUAL_THRESHOLD_SECONDS) {
        return 'overrun';
    }
    if (deltaSeconds <= -MEETINGS_PLANNED_VS_ACTUAL_THRESHOLD_SECONDS) {
        return 'underrun';
    }
    return 'onTime';
};
export var emptyMeetingsPlannedVsActualRawCounts = function () { return ({
    overrun: emptyMeetingLoadRawCounts(),
    underrun: emptyMeetingLoadRawCounts(),
    onTime: emptyMeetingLoadRawCounts()
}); };
/**
 * Meetings by attendee mix. Team internal / cross-team / with-external partition
 * all meetings; external-heavy (&gt;50% external guests) overlaps with-external.
 */
export var MEETINGS_BY_WHO_ATTENDED_KEYS = [
    'teamInternal',
    'crossTeam',
    'withExternal',
    'externalHeavy'
];
export var emptyMeetingsByWhoAttendedRawCounts = function () { return ({
    teamInternal: emptyMeetingLoadRawCounts(),
    crossTeam: emptyMeetingLoadRawCounts(),
    withExternal: emptyMeetingLoadRawCounts(),
    externalHeavy: emptyMeetingLoadRawCounts()
}); };
export var GMAIL_ACTIONS_OVER_TIME_KEYS = [
    'sent',
    'received',
    'opened',
    'replied',
    'linkClicked',
    'otherEvents'
];
export var EMAIL_SUMMARY_REPLY_RATE_KEYS = [
    'received',
    'opened',
    'replied'
];
export var emptyGmailActionsOverTimeCounts = function () { return ({
    sent: 0,
    received: 0,
    opened: 0,
    replied: 0,
    linkClicked: 0,
    otherEvents: 0
}); };
export var DRIVE_ACTIONS_OVER_TIME_KEYS = [
    'created',
    'edited',
    'viewed',
    'commentsPosted',
    'suggestionsPosted',
    'otherEvents'
];
export var emptyDriveActionsOverTimeCounts = function () { return ({
    created: 0,
    edited: 0,
    viewed: 0,
    commentsPosted: 0,
    suggestionsPosted: 0,
    otherEvents: 0
}); };
export var CHAT_ACTIVITY_BREAKDOWN_KEYS = [
    'messagesSent',
    'reactionsSent',
    'messagesReceived',
    'reactionsReceived'
];
export var emptyChatActivityBreakdownCounts = function () { return ({
    messagesSent: 0,
    reactionsSent: 0,
    messagesReceived: 0,
    reactionsReceived: 0
}); };
export var mapGmailEventActionToOverTimeSeries = function (action) {
    switch (action) {
        case GmailEventActionEnum.GMAIL_MESSAGE_SENT:
            return 'sent';
        case GmailEventActionEnum.GMAIL_MESSAGE_RECEIVED:
            return 'received';
        case GmailEventActionEnum.GMAIL_MESSAGE_OPENED:
            return 'opened';
        case GmailEventActionEnum.GMAIL_MESSAGE_REPLIED:
            return 'replied';
        case GmailEventActionEnum.GMAIL_LINK_CLICKED:
        case GmailEventActionEnum.GMAIL_ATTACHMENT_LINK_CLICKED:
            return 'linkClicked';
        default:
            return 'otherEvents';
    }
};
export var SUMMARY_AUDIENCE_KEYS = [
    'inTeam',
    'crossTeam',
    'external'
];
export var emptyGmailSummaryAudienceCounts = function () { return ({
    inTeam: 0,
    crossTeam: 0,
    external: 0
}); };
